import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import {
  getMenus,
  findPane
} from '@/store/_util/util'
// api
import { switchSystemCode } from '@/api/sso/subjectService'
import { getMenuTreeByServiceAndRole, queryECMenuTreeByPlatformCode } from '@/api/sso/role'
import { getPackageStyle, changePackageStyle } from '@/api/sso/user'
import {
  customGroupQueryList,
  customGroupQuery,
  customGroupAdd,
  customGroupDel,
  customGroupEdit,
  bindMenuCustomMenu,
  collectMenu,
  addFavorites,
  delFavorites,
  queryFavorites
} from '@/api/sso/customGroup'
import {
  queryMenuStatus,
  addMenuStatus,
  recordMenuOpt,
  PlatformUniteInterface,
  checkSelMuchJump
} from '@/api'
// types
import {
  PANES_CACHE,
  PANES_HISTORY_CACHE,
  ACTIVE_KEY_CACHE,
  MENUS_ACTIVE_ID_CACHE,
  LANGUAGE,
  USER_INFO,
  HOME_MENU_ID,
  ACCESS_TOKEN
} from '@/store/mutation-types'

import modal from 'ant-design-vue/es/modal'
import message from 'ant-design-vue/es/message'

const entry = {
  namespaced: true,
  state: {
    serviceId: '',
    systemCode: 'ERP',
    menus: [], // 用户系统菜单
    useNewMenu: 2, // 1 侧边菜单布局；旗舰版菜单布局是：2 顶部菜单布局
    menusCache: {},
    menusActiveID: '',
    customMenusDefault: [], // 系统默认的菜单
    customMenus: [], // 用户自定义菜单
    activeKey: 'home',
    homeMenuId: 'home',
    unfold: false, // 展开（true）| 收缩（false）左侧菜单
    menuTypeCurrentId: -1, // 菜单变身选中值
    panes: [], // [{ key: menuId, tab: menuName, systemDomain: systemDomain, path: path, menuUrl: menuUrl, closable: true }]
    iframes: [], // [{ key: menuId, tab: menuName, systemDomain: systemDomain, path: path, menuUrl: menuUrl, closable: true }]
    panesHistory: [], // 缓存用户打开过的10个标签
    favorites: [], // 收藏夹
    ownStore: true, // 是否拥有店铺授权 （控制弹框）
    paidPageFlag: 2 // 是否显示付费页面 1 | 2
  },
  mutations: {
    SET_FAVORITES (state, favorites) {
      state.favorites = favorites
    },
    SET_USE_NEW_MENU (state, useNewMenu) {
      const userInfo = Vue.ls.get(USER_INFO) || {}
      Vue.ls.set(USER_INFO, { ...userInfo, useNewMenu })
      state.useNewMenu = useNewMenu
    },
    ADD_FAVORITES (state, { key }) {
      const index = state.favorites.map(item => item.key).indexOf(key)

      if (index === -1) {
        const pane = findPane(state.menus, { key, lastMenu: 2 })
        pane && state.favorites.push(pane)
      }
    },
    DEL_FAVORITES (state, { key }) {
      const index = state.favorites.map(item => item.key).indexOf(key)
      ~index && state.favorites.splice(index, 1)
    },
    SET_HOME_MENU_ID: (state, homeMenuId) => {
      state.homeMenuId = homeMenuId
      Vue.ls.set(HOME_MENU_ID, homeMenuId)
    },
    SET_SERVICE_ID: (state, id) => {
      state.serviceId = id
    },
    SET_SYSTEM_CODE: (state, code) => {
      state.systemCode = code
    },
    SET_CUSTOM_MENUS: (state, menus) => {
      state.customMenus = menus
    },
    SET_PANES: (state, panes) => {
      state.panes = panes
    },
    SET_UNFOLD: (state, unfold) => {
      state.unfold = unfold
    },
    SET_IFRAMES: (state, iframes) => {
      state.iframes = iframes
    },
    SET_PANES_HISTORY: (state, panes) => {
      state.panesHistory = panes
    },
    REMOVE_PANE: (state, index) => {
      state.panes.splice(index, 1)
    },
    REMOVE_IFRAME: (state, key) => {
      const index = state.iframes.map(item => item.key).indexOf(key)
      ~index && state.iframes.splice(index, 1)
    },
    ADD_PANE: (state, pane) => {
      const isExit = state.panes.find(item => item.key === pane.key)
      const replace = pane.replace
      if (isExit === undefined) {
        const curPaneIndex = state.panes.findIndex(item => item.key === state.activeKey)
        if (replace && ~curPaneIndex) {
          state.panes.splice(curPaneIndex, 1, pane)
        } else {
          state.panes.push(pane)
        }
      }
    },
    ADD_PANE_BY_KEY: (state, key) => {
      const pane = findPane(state.menus, { key })

      if (pane) {
        if (!state.panes.find(item => item.key === pane.key)) {
          state.panes.push(pane)
        }
      }
    },
    ADD_PANE_BY_PATH: (state, path) => {
      const activePath = path.split('?')[0]
      const activeQuery = path.split('?')[1]
      const activePane = findPane(state.menus, { path: activePath, lastMenu: 2 })
      if (activePane) {
        const panesExist = state.panes.find(item => item.key === activePane.key)
        const iframesExist = state.iframes.find(item => item.key === activePane.key)

        if (!panesExist) {
          state.panes.push(activePane)
        }

        if (activePane.systemDomain && !iframesExist) {
          state.iframes.push(activePane)
        }

        state.activeKey = activePane.key
        if (activeQuery) {
          return
        }
        router.push({ path: activePane.path })
      } else {
        state.activeKey = state.homeMenuId
      }
    },
    ADD_PANE_BY_OBJECT: (state, obj) => {
      const { key, path, lastMenu, replace } = obj
      const target = {}

      key && (target.key = key)
      path && (target.path = path)
      lastMenu && (target.lastMenu = lastMenu)

      const activePane = findPane(state.menus, target)
      if (activePane) {
        const panesExist = state.panes.find(item => item.key === activePane.key)
        const iframesExist = state.iframes.find(item => item.key === activePane.key)
        const curPaneIndex = state.panes.findIndex(item => item.key === state.activeKey)
        if (replace && ~curPaneIndex) {
          state.panes.splice(curPaneIndex, 1, activePane)
        } else if (!panesExist) {
          state.panes.push(activePane)
        }

        if (activePane.systemDomain && !iframesExist) {
          if (replace && ~curPaneIndex) {
            state.panes.splice(curPaneIndex, 1, activePane)
          } else {
            state.iframes.push(activePane)
          }
        }

        state.activeKey = activePane.key
      } else {
        state.activeKey = state.homeMenuId
      }
    },
    SET_ACTIVE_KEY: (state, obj) => {
      // console.log('SET_ACTIVE_KEY:obj', obj)
      const { key, ...other } = obj
      const activePane = state.panes.find(pane => pane.key === key)
      const panesHistoryKeys = state.panesHistory.map(item => item.key)
      key !== 'home' && other.statisticsType && recordMenuOpt({ ...other, menuId: Number(key.replace('m_', '')) }).then(() => {}) // 向后端统计点击
      // console.log('SET_ACTIVE_KEY:activePane', activePane)
      if (activePane) {
        if (!activePane.noCache) {
          const index = panesHistoryKeys.indexOf(activePane.key)

          if (~index) {
            state.panesHistory[index].view
              ? (state.panesHistory[index].view += 1)
              : (state.panesHistory[index].view = 1)
          } else {
            state.panesHistory.unshift({ ...activePane, view: 1 })
          }

          state.panesHistory.sort((a, b) => b.view - a.view)
        }

        if (activePane.systemDomain || activePane.external) {
          const iframesExist = state.iframes.find(item => item.key === activePane.key)
          !iframesExist && state.iframes.push(activePane)
        }
        router.push(activePane.path)
      }

      state.activeKey = key
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_MENUS_ACTIVE_ID: (state, key) => {
      state.menusActiveID = key
      Vue.ls.set(MENUS_ACTIVE_ID_CACHE, key)
    },
    SET_MENUS_CACHE: (state, menusCache) => {
      state.menusCache = menusCache || {}
    },
    SET_MENUS_CACHE_ITEM: (state, item) => {
      state.menusCache[item.serviceId] = item.menus
    },
    SET_MENU_TYPE_CURRENT_ID: (state, id) => {
      state.menuTypeCurrentId = id
    },
    SET_OWN_STORE: (state, store) => {
      state.ownStore = store
    },
    SET_PAID_PAGE_FLAG: (state, flag) => {
      state.paidPageFlag = flag
    }
  },
  actions: {
    GenerateMenus ({ dispatch }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          await dispatch('GenerateSystemMenus', { ...params })
          await dispatch('QueryFavorites')
          if (['ERP'].includes(params.systemCode)) {
            await dispatch('GetExistPlatformAccount')
          }
          await switchSystemCode({ systemCode: params.systemCode })
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    QueryFavorites ({ commit, state }) {
      return queryFavorites({ paging: false }).then(({ dataList }) => {
        const favorites = []
        dataList.forEach(({ menuId }) => {
          const pane = findPane(state.menus, { key: `m_${menuId}`, lastMenu: 2 })
          pane && favorites.push(pane)
        })

        commit('SET_FAVORITES', favorites)
      })
    },
    // 获取是否有店铺授权
    GetExistPlatformAccount ({ commit }) {
      return new Promise((resolve) => {
        PlatformUniteInterface({ type: 'getExistPlatformAccount' }).then(({ data }) => {
          // data.result = 1
          if (data?.result) {
            let result = JSON.parse(data.result || '{}')
            // 1存在 0不存在
            commit('SET_OWN_STORE', result?.data?.status)
          }
        }).finally(() => {
          resolve()
        })
      })
    },
    GenerateSystemMenus ({ commit }, params) {
      const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'
      return new Promise((resolve, reject) => {
        // 获取缓存菜单 - 暂时无用，每次都需要刷新
        // if (state.menusCache[serviceId]) {
        //   commit('SET_MENUS', state.menusCache[serviceId])
        //   resolve(state.menusCache[serviceId])
        // }
        getMenuTreeByServiceAndRole({
          ...params,
          microApps: null
        })
          .then(async res => {
            const { code, data } = res
            if (`${code}` === '200' && data) {
              // data.useNewMenu = 1
              const { childMenus, homeMenuId, useNewMenu, showUpdateFlag, packageShowUpdateFlag, packageId } = data
              const usreMenuResponse = await queryECMenuTreeByPlatformCode({})
              // 生成权限管理
              const authSet = findPane(usreMenuResponse?.data?.menuInfoListDTOS || [], { menuName: '权限管理' }, { menuUrl: '/list', lastMenu: 2, selectFlag: 2 }, ['childMenus', 'platformCode', 'menuEnName', 'menuKrName'])
              // 生成账号设置
              const accountSet = findPane(usreMenuResponse?.data?.menuInfoListDTOS || [], { menuName: '账号设置' }, { lastMenu: 2 }, ['childMenus', 'platformCode', 'menuEnName', 'menuKrName', 'selectFlag'])
              authSet.childMenus.push(accountSet)
              // 内嵌用户中心服务框架
              const homeMenu = {
                childMenus: [],
                closable: true,
                key: 'sso-home',
                lastMenu: 2,
                menuEnName: 'User Center',
                menuId: 33189,
                menuKrName: '사용자 센터',
                menuName: '用户中心',
                menuUrl: '/user/home',
                platformCode: 'SSO_SYS_USER_BASE',
                selectFlag: 2
              }
              authSet.childMenus.push(homeMenu)
              // 内嵌应用授权
              const appAuthorization = {
                childMenus: [],
                closable: true,
                key: 'sso-appAuthorization',
                lastMenu: 2,
                menuEnName: 'Application authorization',
                menuId: 33190789,
                menuKrName: '신청 승인',
                menuName: '应用授权',
                menuUrl: '/user/appAuthorization',
                platformCode: 'SSO_SYS_USER_BASE',
                selectFlag: 2
              }
              authSet.childMenus.push(appAuthorization)
              // 内嵌消息列表
              const notification = {
                childMenus: [],
                closable: true,
                key: 'sso-notification',
                lastMenu: 2,
                menuEnName: 'Message list',
                menuId: 3319078912,
                menuKrName: '메시지 목록',
                menuName: '消息列表',
                menuUrl: '/user/notification',
                platformCode: 'SSO_SYS_USER_BASE',
                selectFlag: 2
              }
              authSet.childMenus.push(notification)
              // 内嵌公告列表
              const announcement = {
                childMenus: [],
                closable: true,
                key: 'sso-announcement',
                lastMenu: 2,
                menuEnName: 'Announcement list',
                menuId: 3319078913,
                menuKrName: '공지사항 목록',
                menuName: '公告列表',
                menuUrl: '/user/announcement',
                platformCode: 'SSO_SYS_USER_BASE',
                selectFlag: 2
              }
              authSet.childMenus.push(announcement)
              const usreMenu = getMenus([authSet || {}], { ...params, useNewMenu: 2, lang, tabVisible: false })
              const childMenusArray = [...getMenus(childMenus, { ...params, lang, packageId, useNewMenu, isDemo: true }), ...usreMenu]
              console.log('childMenusArray', childMenusArray)
              const isExit = findPane(childMenusArray, {
                key: `m_${homeMenuId}`
              })
              const _homeMenuId = (Vue.ls.get(HOME_MENU_ID) || '').substring(2)
              if (`${homeMenuId}` !== _homeMenuId && isExit) {
                Vue.ls.remove(PANES_CACHE)
                Vue.ls.remove(PANES_HISTORY_CACHE)
                Vue.ls.remove(MENUS_ACTIVE_ID_CACHE)
                Vue.ls.remove(ACTIVE_KEY_CACHE)
                router.push({ path: isExit.path })
              }
              commit('SET_PAID_PAGE_FLAG', packageShowUpdateFlag === 2 ? false : showUpdateFlag)
              commit('SET_MENUS_CACHE_ITEM', { childMenusArray, ...params })
              commit('SET_MENUS', childMenusArray)
              // commit('SET_USE_NEW_MENU', useNewMenu)
              commit('SET_HOME_MENU_ID', isExit?.key || 'home')
              resolve(childMenusArray)
            } else {
              reject(res)
            }
          })
          .catch(error => {
            // if (error?.data?.useNewMenu) {
            //   commit('SET_USE_NEW_MENU', error.data.useNewMenu)
            // }
            // console.log('error', error)
            reject(error)
          })
      })
    },
    GenerateCustomMenus ({ dispatch, commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const menus = await dispatch('GetCustomMenus', { paging: false })
          commit('SET_CUSTOM_MENUS', menus)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    GetCustomMenus ({ state }, data) {
      return new Promise((resolve, reject) => {
        customGroupQueryList(data)
          .then(res => {
            const { code, dataList } = res
            let customMenus = []

            if (`${code}` === '200' && dataList && dataList.length) {
              customMenus = dataList.map(item => {
                const {
                  id,
                  customMenuName,
                  groupMenuBindDTOS,
                  remark,
                  type
                } = item
                let childMenus = []

                if (groupMenuBindDTOS && groupMenuBindDTOS.length) {
                  childMenus = groupMenuBindDTOS.map(menu => {
                    const { menuId } = menu
                    const menuData = findPane(state.menus, {
                      menuId,
                      lastMenu: 2
                    })
                    return (
                      menuData && {
                        menuId,
                        key: menuData.key,
                        tab: menuData.tab,
                        menuName: menuData.menuName,
                        menuEnName: menuData.menuEnName,
                        menuKrName: menuData.menuKrName,
                        platformExpireTime: menuData.platformExpireTime,
                        assetsExpireTime: menuData.assetsExpireTime,
                        lastMenu: 2,
                        childMenus: []
                      }
                    )
                  })
                }

                return {
                  menuId: id,
                  key: `c_${id}`,
                  menuType: type,
                  tab: customMenuName,
                  special: data.type,
                  closable: true,
                  childMenus: childMenus.filter(item => item),
                  remark: remark || ''
                }
              })
            }

            resolve(customMenus)
          })
          .catch(error => reject(error))
      })
    },
    // 获取默认自定义菜单
    GetCustomMenu ({ state }, data) {
      return new Promise((resolve, reject) => {
        customGroupQuery(data)
          .then(res => {
            const { code, data } = res
            let customMenu = null

            if (`${code}` === '200' && data) {
              const { id, groupMenuBindDTOS, remark } = data
              let childMenus = []

              if (groupMenuBindDTOS && groupMenuBindDTOS.length) {
                childMenus = groupMenuBindDTOS.map(menu => {
                  const { menuId } = menu
                  const menuData = findPane(state.menus, {
                    menuId,
                    lastMenu: 2
                  })
                  return (
                    menuData && {
                      menuId,
                      key: menuData.key,
                      tab: menuData.tab,
                      menuName: menuData.menuName,
                      menuEnName: menuData.menuEnName,
                      menuKrName: menuData.menuKrName,
                      platformExpireTime: menuData.platformExpireTime,
                      assetsExpireTime: menuData.assetsExpireTime,
                      lastMenu: 2,
                      childMenus: []
                    }
                  )
                })
              }

              customMenu = {
                menuId: id,
                key: 'c_default',
                tab: 'ERP快速上手',
                special: 3,
                closable: false,
                childMenus: childMenus.filter(item => item),
                remark: remark || ''
              }
            }
            resolve(customMenu)
          })
          .catch(error => reject(error))
      })
    },
    AddCustomMenu ({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await customGroupAdd(data)
          await dispatch('GenerateCustomMenus')
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    RemoveCustomMenu ({ dispatch }, groupId) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await customGroupDel({ groupId })
          await dispatch('GenerateCustomMenus')
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    EditCustomMenu ({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await customGroupEdit(data)
          await dispatch('GenerateCustomMenus')
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    EditSystemMenu ({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await bindMenuCustomMenu(data)
          await dispatch('GenerateCustomMenus')
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    SetActiveKey: async ({ commit, state }, obj) => {
      const { key } = obj
      const isExit = state.panes.find(pane => pane.key === key)
      const activePane = findPane(state.menus, { key }, undefined, ['systemCode'])

      if (!activePane && !isExit) {
        return modal.warning({
          title: '温馨提示',
          content: '抱歉，您没有访问权限，请联系管理人员',
          okText: '我知道了'
        })
      }

      console.log('SetActiveKey:activePane', activePane)

      // 判断平台是否到期
      if (activePane && activePane.platformExpireTime && Date.now() > Date.parse(activePane.platformExpireTime)) {
        return modal.confirm({
          title: '温馨提示',
          content: '该功能的平台已到期，为避免影响团队成员正常使用，请尽快完成续费',
          okText: '续费',
          cancelText: '取消',
          onOk () {
            window.location.href = '/#/company/serve/serve-manage'
          }
        })
      }

      // 判断功能是否到期
      if (activePane && activePane.assetsExpireTime && Date.now() > Date.parse(activePane.assetsExpireTime)) {
        return modal.confirm({
          title: '温馨提示',
          content: '该功能已到期，为避免影响团队成员正常使用，请尽快完成续费',
          okText: '续费',
          cancelText: '取消',
          onOk () {
            window.location.href = '/#/company/serve/serve-manage'
          }
        })
      }

      if (isExit || key === 'home') {
        commit('SET_ACTIVE_KEY', obj)
      } else if (activePane) {
        // 亿数通往外跳
        if (['SELMUCH_ADS'].includes(activePane.systemCode) && process.env.NODE_ENV === 'production') {
          const curSystem = store.getters.microApps.find(system => system.systemCode === activePane.systemCode)
          const connector = ~activePane['menuUrl'].indexOf('?') ? '&' : '?'
          const { data } = await checkSelMuchJump()
          if (data?.systemUrl) {
            window.open(`${curSystem.entry.replace(/\/$/, '')}${activePane.menuUrl}${connector}token=${Vue.ls.get(ACCESS_TOKEN)}&resource=sso`, '_blank')
          }
          return
        }
        commit('ADD_PANE_BY_OBJECT', obj)
        commit('SET_ACTIVE_KEY', obj)
      }
    },
    SetActiveAsync ({ commit, state }, pane) {
      return new Promise((resolve, reject) => {
        const defaultOptions = {
          verify: 'warning',
          next: true,
          routerMethods: 'push', // push | replace | go | back | forward
          noCache: true,
          external: false,
          replace: false
        }
        let { systemName, menuName, systemCode, verify, next, noCache, routerMethods, replace, external, key, ...target } = { ...defaultOptions, ...pane }
        const pathDots = (target?.path || '').split('?')
        if (pathDots.length === 2) {
          target.path = pathDots[0]
        }
        const activePane = !external ? findPane(state.menus, target) : {
          menuUrl: target.menuUrl,
          menuParams: target.menuParams,
          path: target.path,
          menuName,
          key,
          closable: true,
          external
        }

        console.log('activePane', activePane)
        if (key && activePane) activePane.key = key

        if (menuName && activePane) activePane.menuName = menuName

        if (pathDots.length === 2 && activePane) activePane.path = activePane.path + '?' + pathDots[1]

        if (!activePane && verify) {
          const error = {
            code: 401,
            title: '温馨提示',
            content: '抱歉，您没有访问权限，请联系管理人员',
            okText: '我知道了'
          }
          verify === 'warning' && modal.warning(error)
          reject(error)
          return
        }

        if (!noCache && activePane) {
          const panesHistoryKeys = state.panesHistory.map(item => item.key)
          const index = panesHistoryKeys.indexOf(activePane.key)

          if (~index) {
            state.panesHistory[index].view
              ? (state.panesHistory[index].view += 1)
              : (state.panesHistory[index].view = 1)
          } else {
            state.panesHistory.unshift({ ...activePane, view: 1 })
          }

          state.panesHistory.sort((a, b) => b.view - a.view)
        }

        if ((activePane?.systemDomain && (systemName === 'iframe' || !systemName)) || external) {
          const iframesExist = state.iframes.find(item => item.key === activePane.key)
          !iframesExist && state.iframes.push(activePane)
        }
        commit('ADD_PANE', { ...activePane, replace })
        state.activeKey = activePane?.key

        next && router[routerMethods](`${activePane.path}`)
        resolve(activePane)
      })
    },
    SetActivePath ({ commit, state, dispatch }, pane) {
      return new Promise((resolve, reject) => {
        const activePane = findPane(state.menus, { path: pane.path, lastMenu: 2 })
        console.log('activePane', activePane, state.menus)
        if (!activePane && pane.permissions) {
          const error = {
            code: 401
          }
          reject(error)
          return modal.warning({
            title: '温馨提示',
            content: '抱歉，您没有访问权限，请联系管理人员',
            okText: '我知道了'
          })
        }
        const panesExist = state.panes.find(item => item.key === activePane?.key)

        if (activePane || panesExist) {
          commit('ADD_PANE_BY_PATH', pane.path)
        } else {
          dispatch('Navigator', activePane || pane)
        }
        resolve()
      })
    },
    Navigator ({ commit }, pane) {
      commit('ADD_PANE', { ...pane })
      commit('SET_ACTIVE_KEY', { ...pane })
    },
    ClosePane ({ commit, state }, key) {
      const keys = state.panes.map(item => item.key)
      const index = keys.indexOf(key)
      // 首页不可关闭
      if (index === 0) {
        message.warning('首页不可关闭')
        return
      }
      if (~index) {
        commit('REMOVE_PANE', index)
        commit('REMOVE_IFRAME', key)
      }

      if (state.activeKey === key) {
        commit('SET_ACTIVE_KEY', { key: state.panes[index - 1]?.key || state.homeMenuId })
      }
    },
    CloseAllPane ({ commit, state }) {
      const homeMenu = state.panes.find(item => !item.closable)
      commit('SET_PANES', [homeMenu && homeMenu])
      commit('SET_IFRAMES', [])
      commit('SET_ACTIVE_KEY', { key: state.homeMenuId })
    },
    CloseLeftPanes ({ commit, state }, key) {
      const keys = state.panes.map(item => item.key)
      const index = keys.indexOf(key)
      const homeMenu = state.panes.find(item => !item.closable)
      if (index === 0) {
        return
      }
      if (~index) {
        commit('SET_PANES', [homeMenu && homeMenu, ...state.panes.slice(index)])
        commit('SET_IFRAMES', state.iframes.filter(item => item.key === key))
      }
    },
    CloseRightPanes ({ commit, state }, key) {
      const keys = state.panes.map(item => item.key)
      const index = keys.indexOf(key)
      if (index === 0) {
        return
      }
      if (state.activeKey === 'home' && keys.length) {
        commit('SET_PANES', [])
        commit('SET_IFRAMES', [])
      } else if (~index && index !== keys.length - 1) {
        commit('SET_PANES', state.panes.slice(0, index + 1))
        commit('SET_IFRAMES', state.iframes.filter(item => item.key === key))
      }
    },
    // 将二级菜单钉到左侧菜单
    PushpinMenu ({ state }, { key, pushpin }) {
      state.menus.forEach(({ childMenus }) => {
        childMenus.forEach(item => {
          if (item.key === key) {
            item.pushpin = !item.pushpin
          }
        })
      })
      collectMenu({ menuId: key.replace('m_', ''), optType: pushpin ? 1 : 2 })
    },
    // 收藏页面
    AddFavorites ({ commit }, { key }) {
      const menuId = key.replace('m_', '')
      return addFavorites({ menuId }).then(res => {
        commit('ADD_FAVORITES', { key })
      })
    },
    // 取消收藏
    DelFavorites ({ commit }, { key }) {
      const menuId = key.replace('m_', '')
      return delFavorites({ menuId }).then(res => {
        commit('DEL_FAVORITES', { key })
      })
    },
    async SavePanes ({ state }) {
      const { serviceId, systemCode } = state
      const CACHE_KEY = `${serviceId}${systemCode}`
      const panesCache = Vue.ls.get(PANES_CACHE) || {}
      const panesHistoryCache = Vue.ls.get(PANES_HISTORY_CACHE) || {}
      const activeKeyCache = Vue.ls.get(ACTIVE_KEY_CACHE) || {}
      Vue.ls.set(PANES_CACHE, {
        ...panesCache,
        [CACHE_KEY]: state.panes.filter(item => item.closable) // 不保存首页
      })
      Vue.ls.set(ACTIVE_KEY_CACHE, {
        ...activeKeyCache,
        [CACHE_KEY]: state.activeKey
      })
      Vue.ls.set(PANES_HISTORY_CACHE, {
        ...panesHistoryCache,
        [CACHE_KEY]: state.panesHistory
      })
      addMenuStatus({ saveMenuStatus: state.unfold })
    },
    saveUseNewMenu ({ commit }, useNewMenu) {
      changePackageStyle({ styleCode: useNewMenu }).then(() => {
        commit('SET_USE_NEW_MENU', useNewMenu)
      })
    },
    async InitPanes ({ commit, state, dispatch }, { serviceId, systemCode, activePath }) {
      // console.log('InitPanes')
      try {
        await dispatch('GenerateCustomMenus')
      } catch (e) {}

      const CACHE_KEY = `${serviceId}${systemCode}`
      const activeKeyCache = Vue.ls.get(ACTIVE_KEY_CACHE) || {}
      const panesCache = Vue.ls.get(PANES_CACHE) || {}
      const panesHistoryCache = Vue.ls.get(PANES_HISTORY_CACHE) || {}
      const userInfo = Vue.ls.get(USER_INFO) || {}
      const menusActiveID = Vue.ls.get(MENUS_ACTIVE_ID_CACHE) || (state.customMenus.length && state.customMenus[0].key) || '__HISTORY__'
      const panes = [Object.assign({ key: 'home', tab: '首页' }, findPane(state.menus, { key: state.homeMenuId }), { noCache: true, closable: false })]
      const panesHistory = []
      const activeKey = activeKeyCache[CACHE_KEY] || state.homeMenuId || 'home'
      // 重命名网页标题
      document.title = (userInfo.onlineSubjectName || '') + '-易仓用户中心'
      // 获取历史打开页面
      if (panesCache[CACHE_KEY]?.length) {
        panes.push(...panesCache[CACHE_KEY].map(item => item.external ? item : findPane(state.menus, { key: item.key, lastMenu: 2 })).filter(item => item && item.key !== state.homeMenuId))
      }

      // 获取历史记录
      if (panesHistoryCache[CACHE_KEY]?.length) {
        panesHistory.push(
          ...panesHistoryCache[CACHE_KEY].map(item =>
            findPane(state.menus, { key: item.key, lastMenu: 2 })
          ).filter(item => item)
        )
      }

      // 获取用户状态（展开|收缩左侧菜单开关）
      queryMenuStatus({}).then(({ data }) => {
        const unfold = data.saveMenuStatus === null ? true : JSON.parse(data.saveMenuStatus)
        commit('SET_UNFOLD', unfold)
      })
      // 获取用户套餐样式
      const styleRes = await getPackageStyle({})
      const useNewMenu = styleRes.data ? styleRes.data * 1 : 2
      commit('SET_USE_NEW_MENU', useNewMenu)

      commit('SET_SERVICE_ID', serviceId)
      commit('SET_SYSTEM_CODE', systemCode)
      commit('SET_MENUS_ACTIVE_ID', menusActiveID)
      commit('SET_PANES', panes)
      commit('SET_PANES_HISTORY', panesHistory)

      /**
       * 优先匹配当前路径
       * 其次匹配上次访问的页面
       * 否则打开首页
       */
      // console.log('activePath', activePath)
      if (/#/.test(activePath)) {
        const activePane = panes.find(item => item.key === activeKey)
        if (activePane?.external) {
          state.iframes.push(activePane)
          state.activeKey = activePane.key
          router.push({ path: activePane.path })
        } else {
          commit('ADD_PANE_BY_PATH', activePath)
        }
      } else {
        dispatch('SetActiveKey', { key: activeKey })
      }
    }
  }
}

export default entry
